import { ref, watch, type Ref } from "vue";
import { backupRepository } from "@/repositories/backup.repository";
import type { DRBackup } from "@/types";

export const useGetBackups = (drawingId: Ref<number | undefined>) => {
  const data = ref<DRBackup[]>([]);

  const loading = ref(false);

  const fetch = async () => {
    if (!drawingId.value) throw new Error("No drawing id provided");
    loading.value = true;
    try {
      data.value = await backupRepository.fetchAllByNewest(drawingId.value);
    } catch (error) {
      console.error("Error fetching backups:", error);
    } finally {
      loading.value = false;
    }
  };

  watch(
    drawingId,
    (id) => {
      if (id) fetch();
    },
    { immediate: true },
  );

  return {
    data,
    fetch,
    loading,
  };
};
